<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="float-left">06. Business Information</h5>
<!--        <div class="float-right mb-1">-->
<!--          <div v-if="businesses.length > 0">-->
<!--            <span class="badge badge-success mr-2">Total Search Data Found: {{ businesses.length }}</span>-->
<!--            <download-excel-->
<!--                    class = "btn btn-light"-->
<!--                    :data = "businesses"-->
<!--                    :fields = "business_fields"-->
<!--                    :meta="json_meta"-->
<!--                    worksheet = "Business"-->
<!--                    name = "business.xls">-->
<!--              Download Excel-->
<!--            </download-excel>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <p v-if="businesses.length === 0">N/A</p>
    <div class="scrollable-table" v-if="businesses.length > 0">
      <table class="table table-bordered table-hover dt-table table-striped table-sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Name of Business</th>
            <th>Business Operator</th>
            <th>Father's Name</th>
            <th>Mother's Name</th>
            <th>Type of Business</th>
            <th>Address</th>
            <th>Capital</th>
            <th>Yearly Income</th>
            <th># of Employees</th>
            <th>Trade Lic no.</th>
            <th>VAT Reg. no</th>
            <th>TIN no.</th>
            <th>Deposit</th>
          </tr>
        </thead>
        <tbody>
          <tr li v-for="(business, index) in businesses" :key="business.id">
            <td>{{ index + 1 }}</td>
            <td>{{ business.business_name }}</td>
            <td>{{ business.operator_name }}</td>
            <td>{{ business.operator_father }}</td>
            <td>{{ business.operator_mother }}</td>
            <td>{{ business.business_type }}</td>
            <td>{{ business.address }}</td>
            <td>{{ business.capital }}</td>
            <td>{{ business.yearly_income }}</td>
            <td>{{ business.employees_no }}</td>
            <td>{{ business.trade_licensing_no }}</td>
            <td>{{ business.vat_reg_no }}</td>
            <td>{{ business.tin_no }}</td>
            <td>{{ business.advance_deposite }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  data() {
    return {
      businesses: [],
      business_fields: {
        'Name of Business': 'business_name',
        'Business Operator': 'operator_name',
        'Father`s Name': 'operator_father',
        'Mother`s Name': 'operator_mother',
        'Type of Business': 'business_type',
        'Address': 'address',
        'Capital': 'capital',
        'Yearly Income': 'yearly_income',
        '# of Employees': 'employees_no',
        'Trade Lic no.': 'trade_licensing_no',
        'VAT Reg. no': 'vat_reg_no',
        'TIN no.': 'tin_no',
        'Deposit': 'advance_deposite'
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },

  mounted() {
    this.getPersonLands();
  },
  methods: {
    getPersonLands() {
      http
        .get("api/ses/businesses/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.businesses = response.data.businesses;
          }
        });
    }
  },
};
</script>
